<template>
  <div v-once class="an-legal container">
    <router-link class="btn" to="/">Zur Startseite</router-link>

    <h1 id="impressum">Impressum</h1>

    <p>
      Impressum und Offenlegung gemäß §§ 24, 25 Mediengesetz iVm § 5
      E-Commerce-Gesetz für Online-Medien der Fachhochschule St. Pölten GmbH;
      Hinweis gemäß § 14 Unternehmensgesetzbuch
    </p>

    <p>
      Entstanden im Rahmen des Projektsemesters Medientechnik, FH St. Pölten,
      2020
    </p>

    <h2>MedieninhaberIn und HerausgeberIn</h2>

    Fachhochschule St. Pölten GmbH

    <h2>Firmensitz und Geschäftsanschrift</h2>

    <p>
      Matthias Corvinus-Strasse 15, 3100 St. Pölten<br />
      Firmenbuch LG St. Pölten, FN 146616m<br />
      UID ATU 53208201<br />
      DVR: 1028669F
    </p>

    <h2>Vertretungsbefugte Organe Geschäftsführung</h2>

    <p>DI Gernot Kohl, MSc</p>

    <h2>Kontakt</h2>

    <p>
      Fachhochschule St. Pölten GmbH<br />
      Matthias Corvinus-Strasse 15, 3100 St. Pölten<br />
      Tel. +43 (0)2742 313228-333<br />
      Fax: +43 (0)2742 313228-339<br />
      E-mail: csc@ustp.at
    </p>

    <h3>Team:</h3>
    <p>
      Wolfgang Aigner, Magdalena Boucher, Felix De Montis, Barbara Ehrenhöfer,
      Johannes Gerstbauer, Florian Grassinger, Stefanie Größbacher, Peter
      Judmaier, Jan Kollars, Johannes Pflegerl, Lydia Popp, Alexander Rind,
      Annika Schweighofer, Christina Stoiber
    </p>

    <h2>Gegenstand des Unternehmens</h2>

    <p>
      Die Vorbereitung und Durchführung von Fachhochschul-Studiengängen und der
      Betrieb einer Fachhochschule in St. Pölten mit mehreren
      Fachhochschulstudiengängen, all dies nach den Zielen und leitenden
      Grundsätzen von Fachhochschulstudiengängen im Sinne des § 3 FHStG. Die
      Erbringung von Dienstleistungen in Bereichen, in denen die Gesellschaft
      forschend und lehrend tätig ist, an Dritte, die Veranstaltung von Aus- und
      Fortbildungslehrgängen, der Betrieb eines Studierendenheimes und einer
      Studierendenmensa. Innerhalb dieser Grenzen ist die Gesellschaft zu allen
      Geschäften und Maßnahmen berechtigt, die zur Erreichung des
      Gesellschaftszwecks notwendig erscheinen. Die Gesellschaft verfolgt
      ausschließlich und unmittelbar gemeinnützige Zwecke im Sinne der BAO, ihre
      Tätigkeit ist nicht auf Gewinn ausgerichtet. Die Mittel der Gesellschaft
      dürfen nur für die Erreichung der gemeinnützigen Ziele der Fachhochschule
      verwendet werden.
    </p>

    <h2>Gesellschafter/Beteiligungen</h2>

    <p>Gesellschafterinnen der Fachhochschule St. Pölten GmbH sind</p>

    <ul>
      <li>
        zu 74% die Hochschulen St. Pölten Holding GmbH (FN 467878 g), deren
        Alleingesellschafterin die Landeshauptstadt St. Pölten ist, und
      </li>

      <li>zu 26% das Land Niederösterreich.</li>
    </ul>

    <h2>Erklärung über die grundlegende Richtung</h2>

    <p>
      Förderung und Bewerbung der Fachhochschule St. Pölten sowie
      Berichterstattung über Themenfelder, welche insbesondere im Zusammenhang
      mit der Lehr- und Forschungstätigkeit jener an der Fachhochschule St.
      Pölten etablierten Studiengänge stehen.
    </p>

    <h2>Anzuwendende Rechtsvorschriften</h2>
    <ul>
      <li>Mediengesetz</li>
      <li>E-Commerce-Gesetz</li>
      <li>Unternehmensgesetzbuch</li>
      <li>Fachhochschul-Studiengesetz</li>
      <li>Hochschul-Qualitätssicherungsgesetz</li>
    </ul>

    <p>Sämtliche Gesetze sind u.a. zugänglich unter http://www.ris.bka.gv.at</p>

    <h2>Aufsichtsbehörde</h2>

    <p>
      im Rahmen des Hochschul-Qualitätssicherungsgesetzes und des
      Fachhochschul-Studiengesetzes: Agentur für Qualitätssicherung und
      Akkreditierung Austria
    </p>

    <h2>Technische Umsetzung und Support</h2>

    <p>
      Die technische Betreuung des WWW-Servers www.ustp.at erfolgt durch die
      Abteilung IT und Infrastruktur der Fachhochschule St. Pölten. Bei
      technischen Problemen richten Sie Ihre E-Mail bitte an den Webmaster.
    </p>

    <h2>Haftung</h2>

    <p>
      Sämtliche Texte auf der Homepage der Fachhochschule St. Pölten wurden
      sorgfältig geprüft. Dessen ungeachtet kann keine Garantie für die
      Richtigkeit, Vollständigkeit und Aktualität der Angaben übernommen werden.
      Eine Haftung der Fachhochschule St. Pölten wird daher ausgeschlossen. Die
      Links zu anderen Webseiten wurden sorgfältig ausgewählt. Da die
      Fachhochschule St. Pölten auf deren Inhalt keinen Einfluss hat, übernimmt
      die Fachhochschule St. Pölten dafür keine Verantwortung.
    </p>

    <h1 id="datenschutz">Datenschutzerklärung</h1>

    <h2>Erklärung zur Informationspflicht</h2>

    <p>
      Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Wir
      verarbeiten Ihre Daten daher ausschließlich auf Grundlage der gesetzlichen
      Bestimmungen (DSGVO, TKG 2003). In diesen Datenschutzinformationen
      informieren wir Sie über die wichtigsten Aspekte der Datenverarbeitung im
      Rahmen unserer Website.
    </p>

    <p>
      Beim Besuch unserer Webseite wird Ihre IP-Adresse, Beginn und Ende der
      Sitzung für die Dauer dieser Sitzung erfasst. Dies ist technisch bedingt
      und stellt damit ein berechtigtes Interesse iSv Art 6 Abs 1 lit f DSGVO
      dar. Soweit im Folgenden nichts anderes geregelt wird, werden diese Daten
      von uns nicht weiterverarbeitet.
    </p>

    <h2>Kontakt mit uns</h2>

    <p>
      Wenn Sie per Formular auf der Website oder per E-Mail Kontakt mit uns
      aufnehmen, werden Ihre angegebenen Daten zwecks Bearbeitung der Anfrage
      und für den Fall von Anschlussfragen sechs Monate bei uns gespeichert.
      Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
    </p>

    <h2>Cookies</h2>

    <p>
      Unsere Website verwendet so genannte Cookies. Dabei handelt es sich um
      kleine Textdateien, die mit Hilfe des Browsers auf Ihrem Endgerät abgelegt
      werden. Sie richten keinen Schaden an. Wir nutzen Cookies dazu, unser
      Angebot nutzerfreundlich zu gestalten. Einige Cookies bleiben auf Ihrem
      Endgerät gespeichert, bis Sie diese löschen. Sie ermöglichen es uns, Ihren
      Browser beim nächsten Besuch wiederzuerkennen. Wenn Sie dies nicht
      wünschen, so können Sie Ihren Browser so einrichten, dass er Sie über das
      Setzen von Cookies informiert und Sie dies nur im Einzelfall erlauben. Bei
      der Deaktivierung von Cookies kann die Funktionalität unserer Website
      eingeschränkt sein.
    </p>

    <h2>Ihre Rechte</h2>

    <p>
      Ihnen stehen bezüglich Ihrer bei uns gespeicherten Daten grundsätzlich die
      Rechte auf Auskunft, Berichtigung, Löschung, Einschränkung,
      Datenübertragbarkeit, Widerruf und Widerspruch zu. Wenn Sie glauben, dass
      die Verarbeitung Ihrer Daten gegen das Datenschutzrecht verstößt oder Ihre
      datenschutzrechtlichen Ansprüche sonst in einer Weise verletzt worden
      sind, können Sie sich bei uns unter datenschutz@ustp.at oder der
      Datenschutzbehörde beschweren.
    </p>

    <h2>Sie erreichen uns unter folgenden Kontaktdaten:</h2>

    <p>
      Fachhochschule St. Pölten GmbH<br />
      Matthias Corvinus Straße 15<br />
      3100 St. Pölten<br />
      datenschutz@ustp.at
    </p>
  </div>
</template>

<script>
export default {
  name: 'Legal'
};
</script>

<style lang="scss">
.an-legal * {
  margin: revert;
}

.an-legal .btn {
  margin-top: $spacer * 2;
}
</style>
